/* eslint-disable @typescript-eslint/camelcase */
import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";

import { initPreConfig } from "./utils/preConfig";

initPreConfig(); // triggers once globally at startup

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(<App />);
